import React from 'react'
import PropTypes from 'prop-types'
import { withStyles, makeStyles } from '@material-ui/core/styles'
import {
    Slider as MuiSlider,
    Grid,
    Input,
    Tooltip,
    Typography
} from '@material-ui/core'
import { handleNumberChange } from '../../utils'

const StyledSlider = withStyles((theme) => ({
    root: {
        color: theme.palette.primary
    },
    thumb: {
        height: 16,
        width: 16,
        backgroundColor: theme.palette.grey[50],
        border: '1px solid currentColor',
        marginTop: -6,
        marginLeft: -6
    },
    track: {
        height: 4,
        borderRadius: 2
    },
    rail: {
        height: 4,
        borderRadius: 2,
        backgroundColor: theme.palette.primary.dark
    }
}))(MuiSlider)

const useStyles = makeStyles((theme) => ({
    root: {},
    label: {
        cursor: 'help',
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    },
    input: {
        width: 50
    }
}))

const ThumbComponent = (props) => {
    return <span {...props} tabIndex={-1} />
}

const Slider = ({ tooltip = '', title, value, min, max, step, onChange }) => {
    const classes = useStyles()

    const handleChange = (event, value = null) => {
        handleNumberChange(value || event.target.value || 0, onChange)
    }

    return (
        <div className={classes.root}>
            <Tooltip title={tooltip}>
                <Typography gutterBottom color={'textSecondary'}>
                    {title}
                </Typography>
            </Tooltip>
            <Grid container spacing={2} alignItems="center">
                <Grid item xs>
                    <StyledSlider
                        ThumbComponent={ThumbComponent}
                        value={value}
                        min={min}
                        max={max}
                        step={step}
                        onChange={handleChange}
                        name={title}
                    />
                </Grid>
                <Grid item>
                    <Input
                        className={classes.input}
                        value={value}
                        onChange={handleChange}
                        name={title}
                        inputProps={{
                            step,
                            min,
                            'aria-label': title,
                            'aria-describedby': tooltip
                        }}
                    />
                </Grid>
            </Grid>
        </div>
    )
}

Slider.defaultProps = {
    step: 1,
    min: 0
}

Slider.propTypes = {
    title: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    min: PropTypes.number,
    max: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    step: PropTypes.number,
    tooltip: PropTypes.string
}

export default Slider
